import { Box, Typography } from "@bca/ui-library";
import NoTransportSVG from "../Icons/NoTransportSVG";

const Offsite: React.FunctionComponent = () => {
  return (
    <Box display="flex" flexDirection="row" alignItems="flex-start" width="50%">
      <NoTransportSVG />
      <Box display="flex" flexDirection="column" marginLeft={2}>
        <Typography
          variant="h6"
          color="footer-blue"
          fontWeight="medium"
          marginTop={0}
          marginBottom={1}
        >
          Offsite
        </Typography>
      </Box>
    </Box>
  );
};

export default Offsite;
